var render, staticRenderFns
import script from "./Asia.vue?vue&type=script&lang=js&"
export * from "./Asia.vue?vue&type=script&lang=js&"
import style0 from "@/assets/themes/ea-vgas/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports